/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Primary_ToolbarInputs */

const en_primary_toolbar = /** @type {(inputs: Primary_ToolbarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primary Toolbar`)
};

const fr_primary_toolbar = /** @type {(inputs: Primary_ToolbarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Barre d'outils principale`)
};

const de_primary_toolbar = /** @type {(inputs: Primary_ToolbarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primäre Symbolleiste`)
};

const it_primary_toolbar = /** @type {(inputs: Primary_ToolbarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Barra degli strumenti principale`)
};

const ru_primary_toolbar = /** @type {(inputs: Primary_ToolbarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Основная панель инструментов`)
};

const es_primary_toolbar = /** @type {(inputs: Primary_ToolbarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Barra de herramientas principal`)
};

const zh_cn2_primary_toolbar = /** @type {(inputs: Primary_ToolbarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`主工具栏`)
};

const ja_primary_toolbar = /** @type {(inputs: Primary_ToolbarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プライマリツールバー`)
};

const hi_primary_toolbar = /** @type {(inputs: Primary_ToolbarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्राथमिक टूलबार`)
};

const pt_pt2_primary_toolbar = /** @type {(inputs: Primary_ToolbarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Barra de ferramentas principal`)
};

/**
* | output |
* | --- |
* | "Primary Toolbar" |
*
* @param {Primary_ToolbarInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const primary_toolbar = /** @type {((inputs?: Primary_ToolbarInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Primary_ToolbarInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_primary_toolbar(inputs)
	if (locale === "de") return de_primary_toolbar(inputs)
	if (locale === "it") return it_primary_toolbar(inputs)
	if (locale === "ru") return ru_primary_toolbar(inputs)
	if (locale === "es") return es_primary_toolbar(inputs)
	if (locale === "zh-CN") return zh_cn2_primary_toolbar(inputs)
	if (locale === "ja") return ja_primary_toolbar(inputs)
	if (locale === "hi") return hi_primary_toolbar(inputs)
	if (locale === "pt-PT") return pt_pt2_primary_toolbar(inputs)
	return en_primary_toolbar(inputs)
});